<template>
  <nav
    aria-labelledby="title-breadcrumb"
    class="breadcrumb only-desktop-block"
  >
    <ol
      itemscope
      itemtype="https://schema.org/BreadcrumbList"
      class="breadcrumb__list"
    >
      <li
        v-for="(link, index) in breadcrumbItems"
        :key="index"
        itemprop="itemListElement"
        itemscope
        itemtype="https://schema.org/ListItem"
        class="breadcrumb__item"
      >
        <SplNuxtLink
          itemprop="item"
          :to="link.url"
          is-external
          :class="breadCrumbClass(index)"
          :aria-current="isLastItem(index) ? 'page' : undefined"
        >
          <span itemprop="name">{{ link.name }}</span>
        </SplNuxtLink>

        <meta
          itemprop="position"
          :content="index.toString()"
        >

        <span class="breadcrumb__item__separator">/</span>
      </li>
    </ol>
  </nav>
</template>

<script lang="ts">
import { unslashUri } from '@/core/ts/util/string'

import SplNuxtLink from './SplNuxtLink.vue'
import { removeCurrentLangFromURL } from '~/core/ts/util/translate'

export default defineNuxtComponent({
  components: {
    SplNuxtLink,
  },
  props: {
    overrideUrl: {
      type: String,
      default: '',
    },
    nameOverrideStack: {
      type: Array as PropType<Array<string>>,
      default: () => [],
    },
  },
  setup(props) {
    const route = useRoute()
    const uri = props.overrideUrl || route.path

    const runtimeConfig = useRuntimeConfig()

    const breadcrumbItems = [{ name: 'Spalopia', url: '/' }]

    let path = uri
    if (runtimeConfig.public.shouldPrependLanguajeToURLs) {
      path = removeCurrentLangFromURL(uri)
    }

    let baseUrl = '/'
    unslashUri(path).split('_').forEach((part) => {
      baseUrl += part + '/'
      breadcrumbItems.push({
        name: part.replace(/-/g, ' '),
        url: baseUrl
      })
    })

    const nameOverrideStack = [...props.nameOverrideStack]
    let offset = 1
    while (nameOverrideStack.length) {
      const name = nameOverrideStack.pop()
      if (!name) {
        break
      }

      breadcrumbItems[breadcrumbItems.length - offset].name = name
      offset ++
    }

    function isLastItem(i: number) {
      return (breadcrumbItems.length - 1) === i
    }

    const breadCrumbClass = (index: number) => ({
      breadcrumb__item__name: isLastItem(index),
      breadcrumb__item__link: !isLastItem(index),
    })

    return {
      breadcrumbItems,
      isLastItem,
      breadCrumbClass,
    }
  },
})
</script>

<style lang="scss" scoped>
.breadcrumb {
  @apply text-sm;
  @apply py-2;

  &__list {
    @apply inline-flex;
  }

  &__item {
    @apply capitalize;

    &__link {
      @apply italic underline;
      @apply font-normal;
    }

    &__name {
      @apply font-bold;
      text-decoration: none !important;
      font-style: normal !important;
    }

    &__separator {
      @apply inline-block;
      @apply mx-1;
    }
    &:last-child &__separator {
      @apply hidden;
    }
  }
}
</style>
